import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { isBrowser } from "@/utils/runtime";

export function useAuth() {
  const [session, setSession] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isBrowser || !supabase) {
      setLoading(false);
      return;
    }
    
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub?.subscription?.unsubscribe?.();
  }, []);

  return { session, loading };
}
